import ReactGA from 'react-ga'

export const init = (): boolean => {
  const isGAEnabled = !!import.meta.env.VITE_GOOGLE_ANALYTICS_UA_ID

  if (isGAEnabled) {
    ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_UA_ID)
  }

  return isGAEnabled
}
